import { Box, Modal } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Loader from '../Component/Loader/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { upload, updateImageByUrl } from '../redux/thunk/uploadThunk';

let globalMessageListenerAdded = false;
let globalApiExecuted = false;

const OpenIframeModal = ({
  openIframeModal,
  setOpenIframeModal,
  iframeImageUrl,
  multiple,
  handleSetImage,
  folder,
  editUrl,
  GetFiles,
  forceReloadImage,
  setLoader,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!globalMessageListenerAdded) {
      console.log('🔥 Global message listener installed once');
      globalMessageListenerAdded = true;

      window.addEventListener('message', async (event) => {
        if (['http://localhost:3031/', 'https://spark.shopeasy.ai/'].includes(event.origin)) return;
        console.log(event.data, 'event.data');
        const {
          type,
          cleanBase64,
          mimeType,
          multipleType,
          folderId,
          editUrlCheck, // 👈 replace or copy check
        } = event.data || {};

        if (type !== 'SHOPEASY_AI_IMAGE_RESULT') return;

        if (globalApiExecuted) {
          console.log('⛔ Duplicate message ignored');
          return;
        }

        globalApiExecuted = true;

        try {
          setOpenIframeModal(false);
          setLoader(true);
          console.log('🔥 API EXECUTING ONE TIME ONLY');

          // Convert base64 → file
          const bytes = atob(cleanBase64);
          const buffer = new Uint8Array(Array.from(bytes, (char) => char.charCodeAt(0)));
          const file = new File([buffer], 'edited.png', { type: mimeType });

          if (editUrlCheck) {
            const payload = {
              file,
              url: editUrlCheck,
              folder: folderId,
            };

            const res = await dispatch(updateImageByUrl(payload)).unwrap();
            const newUrl = res?.data?.url;
            if (newUrl) {
              forceReloadImage(newUrl);
            }
          } else {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('folder', folderId);

            const res = await dispatch(upload(formData)).unwrap();
            const uploadedUrl = res?.data?.data?.[0];

            if (uploadedUrl) {
              if (typeof handleSetImage === 'function') {
                handleSetImage(uploadedUrl, multipleType);
              }
              await GetFiles();
            }
          }

          setOpenIframeModal(false);
        } catch (err) {
          console.error('Upload error:', err);
          // setIsNotification(true);
          // setNotificationMsg('Upload failed');
          // setSeverity('error');
        } finally {
          setLoader(false);
        }
      });
    }

    if (openIframeModal) {
      console.log('🔄 Reset globalApiExecuted');
      globalApiExecuted = false;
    }
  }, [openIframeModal]);

  return (
    <>
      {/* {loading ? (
        <Loader />
      ) : ( */}
      <Modal
        open={openIframeModal}
        onClose={() => setOpenIframeModal(false)}
        className='flex items-center justify-center'
      >
        <Box className='bg-white rounded-lg shadow-xl w-[50vw] h-[61vh] p-2 relative'>
          <button
            className='absolute top-3 right-6 text-gray-600 hover:text-black'
            onClick={() => setOpenIframeModal(false)}
          >
            ✕
          </button>

          <iframe
            src={`${process.env.REACT_APP_SPARK_URL}/edit/shopeasy-ai-modal?image=${encodeURIComponent(
              iframeImageUrl,
            )}&multiple=${multiple}&folderId=${folder}&editUrl=${editUrl}`}
            className='w-full h-full rounded border-0'
          ></iframe>
        </Box>
      </Modal>
      {/* )} */}
    </>
  );
};

export default OpenIframeModal;
